export const environment = {
	production: true,
	environmentName: "QA",
	frontUrl: "https://crm-qa.allog.app/",
	mainApiUrl: "https://main.crm-qa.allog.app/",
	/** Default New Monaco base URL (non-FTrade tenants). Used by menu and SSO deep links. */
	monacoUrl: "https://nm-qa.allog.app/#allog/app/",
	/** New Monaco base URL for the FTrade tenant only (menu redirect). */
	monacoUrlFtrade: "https://nm-qa.ftrade.app/#allog/app/",
	/** Tenant id that must redirect to monacoUrlFtrade — mirrors AllogLead.Main FTRADE_TENANT_ID. */
	ftradeTenantId: "ftrade",
	auth: {
		domain: "allog-prod.us.auth0.com",
		clientId: "PbPP2JZHhvsuNOVvjjw5xSscFyKFjx99",
		redirectUri: window.location.origin,
		audience: "https://main.crm-qa.allog.app",
	},
};
